import { render } from "./UserCreateView.vue?vue&type=template&id=6e28b5d6&scoped=true"
import script from "./UserCreateView.vue?vue&type=script&lang=js"
export * from "./UserCreateView.vue?vue&type=script&lang=js"

import "./UserCreateView.vue?vue&type=style&index=0&id=6e28b5d6&lang=less&scoped=true"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e28b5d6"]])

export default __exports__